import { SpinnerIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const WhatsappTemplateListLoadingState: FC = () => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col items-center justify-center gap-3 rounded-2xl border border-secondary-border bg-white p-8'>
      <SpinnerIcon className='size-5 text-primary-600' />
      <p className='text-sm text-secondary-600'>{t('whatsappTemplates.loadingTemplates')}</p>
    </div>
  );
};
